import { render, staticRenderFns } from "./newGamePointsEntry.vue?vue&type=template&id=e842fb9e&"
import script from "./newGamePointsEntry.vue?vue&type=script&lang=js&"
export * from "./newGamePointsEntry.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./newGamePointsEntry.vue?vue&type=style&index=1&id=e842fb9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports